import React from 'react';
import { PASTORS } from './data/pastors';
import Ledger from '../../Components/Ledger/Ledger';

const entries = PASTORS.map((pastor: any) => ({
   name: pastor.name,
   worth: pastor.wealth,
   meta: pastor.country,
   description: pastor.description,
   image: pastor.profile ? `${process.env.PUBLIC_URL}/profiles/${pastor.profile}` : undefined,
}));

const PastorsList = () => <Ledger entries={entries} unit="Est. wealth" />;

export default PastorsList;
